import React from "react";
import { useScreenSize } from "hooks";
import MobileHeader from "./mobile";
import DesktopHeader from "./desktop";

export default function Header() {
  const { isMobile, isDesktop } = useScreenSize();

  let headerContent;

  switch (true) {
    case isMobile:
      headerContent = <MobileHeader />;
      break;
    case isDesktop:
      headerContent = <DesktopHeader />;
      break;
    default:
      headerContent = <div></div>;
  }

  return headerContent;
}
